module.exports = __webpack_public_path__ + "/bundle/asset/2-fef58fa2a57e5e8178bf83a70b98c29a.png";